import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useContext, useState, useEffect } from 'react'
import { APIContext } from 'context/APIContext'
import { ChevronLeftIcon } from '@heroicons/react/20/solid'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'
import ProgramMetadataEditor from 'components/Program/ProgramMetadataEditor'
import MesoVolumeConfigLibrary from 'components/Program/MesoVolumeConfig/MesoVolumeConfigLibrary'

export default function ProgramSettingsView() {

    const navigate = useNavigate()

    const { urlProgramId } = useParams()

    const { GetProgramMetadata } = useContext(APIContext)

    const [programMetadata, setProgramMetadata] = useState(null)

    const InitializeProgramMetadataOnMount = async () => {
        const newProgramMetadata = await GetProgramMetadata(urlProgramId)
        setProgramMetadata(newProgramMetadata)
    }

    useEffect(() => { InitializeProgramMetadataOnMount() }, [])

    if (programMetadata === null) {
        return (
            <ScreenFrame>
                <div className='max-w-3xl mx-auto space-y-4'>
                    <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                    <div className='w-full h-[800px] bg-gray-200 rounded-lg animate-pulse' />
                </div>
            </ScreenFrame>
        )
    }

    return (
        <ScreenFrame>
            <div className='max-w-3xl mx-auto space-y-4'>
                <button
                    type='button'
                    className='flex items-center gap-x-1 pt-2 text-base text-gray-400 hover:text-gray-600'
                    onClick={() => navigate(`/program/${urlProgramId}/playground`)}
                >
                    <ChevronLeftIcon className='h-4 w-4' />
                    Back
                </button>

                <ContentFrame>
                    <div className='w-full divide-y divide-gray-200'>
                        <ProgramMetadataEditor
                            title='Program Levels'
                            items={programMetadata.programLevels ?? []}
                            OnSave={async () => {}}
                            addLabel='Add level'
                            emptyLabel='No levels yet'
                            newItemName='New Level'
                        />
                        
                        <ProgramMetadataEditor
                            title='Program Phases'
                            items={programMetadata.macroVolumePhaseTypes ?? []}
                            OnSave={async () => {}}
                            addLabel='Add phase'
                            emptyLabel='No phases yet'
                            newItemName='New Phase'
                        />

                        <ProgramMetadataEditor
                            title='Program Focuses'
                            items={programMetadata.macroVolumeFocusTypes ?? []}
                            OnSave={async () => {}}
                            addLabel='Add focus'
                            emptyLabel='No focuses yet'
                            newItemName='New Focus'
                        />

                        <MesoVolumeConfigLibrary 
                            programMetadata={programMetadata} 
                        />

                        <ProgramMetadataEditor
                            title='Week Stimuli'
                            items={programMetadata.microVolumeStimulusTypes ?? []}
                            OnSave={async () => {}}
                            addLabel='Add week stimulus'
                            emptyLabel='No week stimuli yet'
                            newItemName='New Week Stimulus'
                            showColorHex={false}
                        />

                        <ProgramMetadataEditor
                            title='Workouts'
                            items={programMetadata.workoutConfigs ?? []}
                            OnSave={async () => {}}
                            addLabel='Add workouts'
                            emptyLabel='No workouts yet'
                            newItemName='New Workout'
                            showColorHex={false}
                        /> 

                        <ProgramMetadataEditor
                            title='Workout Phases'
                            items={programMetadata.workoutPhaseTypes ?? []}
                            OnSave={async () => {}}
                            addLabel='Add workout phase'
                            emptyLabel='No workout phases yet'
                            newItemName='New Workout Phase'
                            showColorHex={false}
                        />
                    </div>
                </ContentFrame>
            </div>
        </ScreenFrame>
    )
}
